import { EnquiryStatus, FacetCounts } from "../../../../types/enquiries";

export type NotificationType = keyof FacetCounts["notifications"];
export type RejectedNotificationType =
  keyof FacetCounts["notifications_inc_rejected"];

export interface NotificationConfig<T extends string = NotificationType> {
  key: T;
  label: string;
  filterValue: string;
}

export type RejectedNotificationConfig =
  NotificationConfig<RejectedNotificationType>;

export const COMPUTED_NOTIFICATIONS: NotificationConfig[] = [
  { key: "follow_up", label: "Follow up required", filterValue: "follow_up" },
  {
    key: "waiting_2hrs",
    label: "Customer waiting 2 hrs",
    filterValue: "untaken_two_hours"
  },
  {
    key: "todays_enquiries",
    label: "Today\u2019s enquiries",
    filterValue: "for_today"
  }
];

export const STANDARD_NOTIFICATIONS: NotificationConfig[] = [
  {
    key: "customer_notes",
    label: "Auto-confirmed notes",
    filterValue: "customer_notes"
  },
  {
    key: "offer_selected",
    label: "Auto conf. offer selected",
    filterValue: "offer_selected"
  },
  {
    key: "deposit_authenticated",
    label: "Card authenticated",
    filterValue: "deposit_authenticated"
  },
  {
    key: "deposit_paid",
    label: "Payment received",
    filterValue: "deposit_paid"
  },
  {
    key: "packages_requested",
    label: "Packages requested",
    filterValue: "packages_requested"
  },
  {
    key: "customer_preorder_added",
    label: "Pre-order added",
    filterValue: "customer_preorder_added"
  },
  {
    key: "customer_preorder_complete",
    label: "Pre-orders complete",
    filterValue: "customer_preorder_complete"
  },
  {
    key: "email_delivery_failed",
    label: "Email delivery issues",
    filterValue: "email_delivery_failed"
  },
  {
    key: "customer_change",
    label: "Booking changed",
    filterValue: "customer_change"
  },
  {
    key: "contract_signed",
    label: "Contract signed",
    filterValue: "contract_signed"
  }
];

export const CUSTOMER_DETAILS_NOTIFICATION: NotificationConfig = {
  key: "customer_details",
  label: "Auto-conf. add details",
  filterValue: "customer_details"
};

export const AUTO_CONFIRM_FILTER_VALUES: ReadonlySet<string> = new Set([
  "customer_notes",
  "offer_selected",
  "customer_details"
]);

export const NEW_MESSAGES_NOTIFICATION: RejectedNotificationConfig = {
  key: "message_received",
  label: "New messages",
  filterValue: "message_received"
};

export const CUSTOMER_CANCELLED_NOTIFICATION: RejectedNotificationConfig = {
  key: "customer_cancelled",
  label: "Customer cancelled",
  filterValue: "customer_cancelled"
};

export const STATUS_CONFIG: Record<
  EnquiryStatus,
  { label: string; initial: string; bgClass: string; textClass: string }
> = {
  new: {
    label: "New",
    initial: "N",
    bgClass: "bg-blue-500",
    textClass: "text-white"
  },
  in_progress: {
    label: "In Progress",
    initial: "I",
    bgClass: "bg-amber-500",
    textClass: "text-white"
  },
  complete: {
    label: "Confirmed",
    initial: "C",
    bgClass: "bg-green-500",
    textClass: "text-white"
  },
  cancelled: {
    label: "Cancelled",
    initial: "X",
    bgClass: "bg-gray-500",
    textClass: "text-white"
  },
  lost: {
    label: "Lost",
    initial: "L",
    bgClass: "bg-red-500",
    textClass: "text-white"
  },
  deleted: {
    label: "Deleted",
    initial: "D",
    bgClass: "bg-red-700",
    textClass: "text-white"
  }
};

export const STATUS_ACTIONS: { value: EnquiryStatus; label: string }[] = [
  { value: "in_progress", label: "Mark in progress" },
  { value: "complete", label: "Confirm enquiry" },
  { value: "cancelled", label: "Cancel enquiry" },
  { value: "deleted", label: "Delete enquiry" }
];
